import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import routes from 'base/constants/routes';
import RecommendationV2 from './RecommendationV2';
import { useLocation, Navigate } from 'react-router-dom';

// PUBLIC_URL is set to '/recommendation' in dev/uat/prod env files so that
// this app is hosted under the /recommendation/ prefix of the shared S3 bucket
// / CloudFront distribution (e.g. dev.seedselector.cropwise.com/recommendation/...).
// The basename keeps all react-router <Link> and navigate() calls relative
// to /recommendation — no CloudFront Function required.
// CRA inlines PUBLIC_URL at build time; fall back to '' for local dev.
const BASENAME = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '');

function RequireSolId({ children }: { children: any } ) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const solId = params.get('sol_id');

  if (!solId) {
    return <Navigate to="/404" />; // or return null;
  }

  return children;
}
const Router = createBrowserRouter([
  {
    path: '*',
    element: <ErrorPage />,
  },
  {
    path: '/',
    element: <RequireSolId><RecommendationV2 /></RequireSolId>,
  },
  {
    path: routes.error,
    element: <ErrorPage type="error" />,
  },
  {
    path: routes.recommendation,
    element: <RecommendationV2 />,
    errorElement: <ErrorPage type="error" isRecommendationPage={true}/>,
  }
], { basename: BASENAME });

export default Router;
